import { authorize, putRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function updateZoneAPI(id, zone) {
  const url = `${AWS_API_URL}/2n/zones/${id}`;
  return putRequest(url, { data: zone }, await authorize());
}

